import React from 'react';
import type { IconProps } from '../types';

export const logodl1 = (props: IconProps) => (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="85px" height="35px" viewBox="0 0 300.000000 120.000000"{...props}>

<g transform="translate(0.000000,112.000000) scale(0.100000,-0.100000)"
fill="#FFFFFF" stroke="none">
<path d="M2564 1039 c-62 -14 -144 -69 -185 -123 -66 -87 -85 -190 -54 -294
15 -49 18 -52 48 -52 40 0 137 14 214 31 l58 12 -35 9 c-76 21 -139 99 -140
174 0 38 43 124 74 146 90 65 223 33 270 -66 23 -48 21 -123 -5 -165 -11 -18
-18 -35 -16 -37 5 -5 151 81 164 98 8 10 6 26 -8 63 -36 97 -122 173 -225 200
-64 17 -99 17 -160 4z"/>
<path d="M2603 925 c-40 -17 -73 -69 -73 -113 0 -111 116 -174 208 -114 78 51
64 191 -23 228 -43 17 -71 17 -112 -1z"/>
<path d="M3058 923 c6 -2 12 -19 12 -36 0 -53 -109 -143 -269 -222 -148 -73
-314 -115 -455 -115 -120 0 -177 47 -148 122 6 18 10 33 8 35 -8 8 -74 -58
-86 -86 -17 -43 2 -96 43 -119 26 -13 57 -17 152 -17 138 1 246 26 403 93 174
75 337 198 371 280 12 29 12 35 -4 52 -10 11 -23 20 -29 19 -6 0 -6 -3 2 -6z"/>
<path d="M387 883 c-12 -12 -7 -41 8 -46 19 -8 60 26 51 41 -8 13 -48 16 -59
5z"/>
<path d="M1230 871 c-15 -29 -12 -41 8 -34 26 9 52 34 46 44 -10 16 -43 9 -54
-10z"/>
<path d="M1637 883 c-12 -11 -8 -41 6 -46 20 -7 47 12 47 33 0 14 -7 20 -23
20 -13 0 -27 -3 -30 -7z"/>
<path d="M125 868 c-13 -44 -46 -252 -41 -265 10 -24 133 -13 179 16 44 27 79
95 80 158 0 40 -4 50 -32 75 -28 25 -38 28 -106 28 -52 0 -77 -4 -80 -12z
m135 -38 c34 -34 21 -128 -23 -177 -21 -24 -74 -40 -87 -27 -4 5 1 57 12 117
20 107 20 107 49 107 16 0 38 -9 49 -20z"/>
<path d="M1524 854 c-10 -15 -19 -38 -20 -53 -1 -14 -8 -61 -15 -105 -13 -74
-12 -79 6 -93 24 -17 77 -14 83 5 2 7 -5 16 -17 19 -24 6 -27 34 -10 112 8 39
15 50 31 53 29 4 36 28 8 28 -17 0 -20 5 -18 27 4 38 -25 42 -48 7z"/>
<path d="M390 810 c-14 -9 -52 -195 -42 -205 3 -3 15 -5 28 -5 17 0 24 7 28
28 34 185 32 211 -14 182z"/>
<path d="M524 810 c-33 -13 -70 -63 -84 -114 -12 -43 -11 -50 7 -74 24 -33 67
-40 93 -17 17 16 21 16 35 2 9 -9 21 -14 29 -11 13 5 52 197 42 212 -7 12 -95
13 -122 2z m61 -62 c-10 -63 -36 -112 -62 -116 -28 -4 -36 23 -24 78 11 51 36
80 68 80 23 0 24 -2 18 -42z"/>
<path d="M724 802 c-43 -28 -78 -102 -70 -150 9 -59 66 -82 109 -44 20 16 20
16 14 -1 -4 -10 -7 -23 -7 -28 0 -25 -42 -49 -85 -49 -32 0 -45 -4 -45 -14 0
-38 105 -29 151 13 26 23 33 41 54 150 14 68 23 126 21 128 -2 2 -28 6 -57 9
-42 4 -61 1 -85 -14z m82 -29 c-3 -10 -8 -35 -12 -56 -7 -41 -38 -87 -59 -87
-33 0 -29 101 6 139 25 27 73 29 65 4z"/>
<path d="M914 812 c-6 -4 -16 -38 -22 -77 -6 -38 -14 -85 -18 -103 -7 -32 -6
-33 22 -30 27 3 30 7 44 74 17 81 32 104 66 104 28 0 28 -3 10 -97 -7 -40 -11
-75 -8 -78 3 -3 15 -5 28 -5 19 0 23 8 33 68 6 37 14 79 17 93 9 48 -53 77
-106 49 -13 -7 -21 -7 -25 0 -7 12 -25 13 -41 2z"/>
<path d="M1163 800 c-41 -25 -63 -68 -63 -124 0 -61 35 -90 98 -83 51 6 78 27
103 82 26 55 24 91 -6 120 -30 31 -86 33 -132 5z m87 -25 c17 -21 4 -97 -22
-130 -13 -17 -28 -25 -42 -23 -18 3 -21 11 -24 53 -4 83 50 145 88 100z"/>
<path d="M1370 807 c-27 -14 -46 -56 -37 -81 4 -9 22 -26 42 -37 19 -12 35
-27 35 -35 0 -19 -32 -34 -58 -27 -12 3 -29 2 -38 -1 -14 -5 -14 -9 -3 -22 20
-25 107 -14 131 16 27 34 19 71 -19 95 -25 15 -32 26 -30 45 2 22 7 25 39 25
41 1 54 8 43 24 -9 15 -74 14 -105 -2z"/>
<path d="M1638 812 c-10 -2 -18 -7 -18 -11 0 -4 -7 -49 -16 -101 -13 -75 -14
-94 -3 -101 28 -17 45 9 58 88 7 43 15 88 18 99 5 23 -10 33 -39 26z"/>
<path d="M1749 797 c-71 -47 -88 -143 -32 -187 27 -21 87 -27 112 -11 21 13 5
29 -24 23 -39 -7 -55 14 -55 70 0 59 35 103 75 96 28 -6 50 5 41 21 -12 19
-81 12 -117 -12z"/>
<path d="M1914 801 c-64 -39 -85 -141 -38 -188 22 -22 32 -25 70 -20 72 8 124
71 124 150 0 69 -85 101 -156 58z m90 -27 c18 -47 -13 -141 -50 -150 -33 -9
-44 2 -44 46 0 69 30 120 71 120 9 0 20 -7 23 -16z"/>
<path d="M2910 663 c-99 -79 -283 -158 -428 -185 -35 -7 -66 -17 -69 -24 -7
-18 163 -350 189 -368 33 -23 66 -20 97 12 17 17 71 131 150 315 68 159 122
290 120 291 -2 2 -29 -16 -59 -41z"/>
<path d="M454 543 c-11 -7 -75 -325 -78 -383 -1 -25 0 -25 97 -30 98 -5 135 1
149 23 13 21 -3 27 -78 27 -61 0 -74 3 -74 16 0 9 12 80 27 158 35 188 35 190
-2 194 -16 1 -35 -1 -41 -5z"/>
<path d="M805 461 c-80 -20 -126 -65 -151 -148 -18 -60 -18 -87 2 -128 33 -69
143 -85 223 -32 54 36 91 112 91 190 0 51 -4 62 -29 88 -16 16 -38 29 -48 29
-10 0 -27 2 -38 4 -11 3 -33 1 -50 -3z m63 -53 c19 -19 14 -127 -7 -174 -32
-70 -86 -94 -115 -52 -32 46 -7 180 41 217 29 23 63 27 81 9z"/>
<path d="M1149 452 c-30 -15 -38 -16 -48 -5 -25 27 -81 -5 -81 -46 0 -15 -9
-78 -20 -140 -11 -62 -18 -116 -15 -122 9 -13 61 -11 73 4 5 6 13 38 17 71 14
122 59 208 99 193 20 -8 20 -11 -4 -146 -11 -62 -18 -116 -15 -122 9 -13 61
-11 72 4 5 6 15 48 22 92 15 93 35 140 68 162 45 30 50 6 25 -128 -12 -66 -20
-125 -17 -130 9 -13 63 -11 72 4 4 6 17 68 29 137 24 138 21 164 -23 181 -36
13 -71 4 -107 -29 -16 -16 -30 -22 -33 -16 -17 48 -63 62 -114 36z"/>
<path d="M1624 458 c-80 -16 -152 -114 -161 -218 -5 -49 -2 -60 18 -84 16 -18
37 -29 65 -33 36 -5 45 -1 79 28 21 19 36 27 33 18 -8 -21 10 -39 37 -39 28 0
45 19 45 50 0 14 10 78 22 143 19 102 20 120 7 128 -8 5 -19 7 -25 5 -6 -3
-27 -1 -45 3 -19 4 -53 3 -75 -1z m66 -60 c-1 -40 -26 -142 -44 -175 -16 -33
-53 -50 -81 -39 -11 4 -15 21 -15 66 0 98 48 170 112 170 22 0 28 -4 28 -22z"/>
<path d="M1903 461 c-49 -12 -83 -39 -99 -76 -19 -47 -4 -77 58 -115 36 -22
48 -36 48 -54 0 -38 -23 -49 -85 -41 -45 5 -56 4 -61 -9 -11 -30 15 -46 75
-46 72 0 120 25 145 74 24 49 12 77 -49 114 -83 50 -66 115 28 110 49 -3 64 6
49 29 -10 16 -70 23 -109 14z"/>
</g>
</svg>
);

export default logodl1;
